import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CreatedPersonalAccessToken, CreatePersonalAccessToken, PersonalAccessToken, PersonalAccessTokenEligibleRight } from '../_models/personalAccessToken';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccessTokenService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getEligibleRights() {
    return this.http.get<PersonalAccessTokenEligibleRight[]>(`${environment.apiUrl}/account/tokens/eligible-rights`, { headers: this.authService.headers });
  }

  getMine() {
    return this.http.get<PersonalAccessToken[]>(`${environment.apiUrl}/account/tokens`, { headers: this.authService.headers });
  }

  create(request: CreatePersonalAccessToken) {
    return this.http.post<CreatedPersonalAccessToken>(`${environment.apiUrl}/account/tokens`, request, { headers: this.authService.headers });
  }

  revokeMine(personalAccessTokenId: string) {
    return this.http.delete(`${environment.apiUrl}/account/tokens/${personalAccessTokenId}`, { headers: this.authService.headers });
  }

  getForUser(userId: string) {
    return this.http.get<PersonalAccessToken[]>(`${environment.apiUrl}/users/${userId}/tokens`, { headers: this.authService.headers });
  }

  revokeForUser(userId: string, personalAccessTokenId: string) {
    return this.http.delete(`${environment.apiUrl}/users/${userId}/tokens/${personalAccessTokenId}`, { headers: this.authService.headers });
  }
}
